




























































































































import {
  Component, PropSync, Vue, Prop,
} from 'vue-property-decorator';
import { PartnersApi } from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import Documents from '@/components/Form/FileUploadForm/Documents/index.vue';
import StandardCard from '@/components/Card/StandardCard/index.vue';

@Component({
  components: {
    Documents,
    StandardCard,
  },
})
export default class FileUploadForm extends Vue {
  @PropSync('documents', {}) documentsSync!: [];

  @Prop({}) partnerID!: string;

  public partnerType: string = '';

  public mounted() {
    this.getPartnerStatus();
  }

  private attachementsInfo: any = {
    parterAgreement: false,
    ApronExchangePartnerAgreement: false,
    questionnaire: false,
    wnine: false,
    insurance: false,
    businessLicense: false,
    healthPermit: false,
    healthInspection: false,
    serveSafe: false,
    allergenManagementCertificate: false,
  };

  public agreementFile: any = {
    url: '/assets/Restaurant contract.pdf',
    name: 'Restaurant contract.pdf',
  };

  public agreementFileFoodtruck: any = {
    url: '/assets/FoodTrucks contract.pdf',
    name: 'FoodTrucks contract.pdf',
  };

  public agreementFileAE: any = {
    url: '/assets/Apron Exchange Agreement.pdf',
    name: 'Apron Exchange Partner Agreement.pdf',
  };

  public safetQuestionaieFile: any = {
    url: '/assets/FSQ.pdf',
    name: 'FSQ.pdf',
  };

  public insuranceFile: any = {
    url: '/assets/COI Sample.pdf',
    name: 'COI Sample.pdf',
  };

  public async getPartnerStatus() {
    try {
      const api = new PartnersApi(AppModule.apiConfig);
      const partnerData = await api.getPartnerById(this.partnerID);
      const partner = partnerData.data;
      (this.partnerType as any) = partner.type;
    } catch {
      //
    }
  }
}
